export default {
  showSubTypes: false,
  activityMapping: [
    {
      type: '',
      subTypes: []
    },
    {
      type: 'Content',
      subTypes: [
        '',
        'Webinar/In-Person',
        'Podcast',
        'For the Record',
        'Up and Running',
        'Report'
      ]
    },
    {
      type: 'Development',
      subTypes: [
        '',
        'Recruitment',
        'Prospecting',
        'Result',
        'Cost Savings Program',
        'Report'
      ]
    },
    {
      type: 'Sponsorships',
      subTypes: []
    },
    {
      type: 'Meeting',
      subTypes: [
        '',
        'In-Person',
        'Virtual',
        'Phone Call'
      ]
    },
    {
      type: 'Renewals',
      subTypes: [
        '',
        'Touchbase',
        'Invoiced',
        'Follow-Up',
        'Survey',
        'Renewal Notes',
        'Drop notes'
      ]
    },
    {
      type: 'Referrals',
      subTypes: [
        '',
        'Direct',
        'Bulk'
      ]
    },
    {
      type: 'Invitation',
      subTypes: []
    },
    {
      type: 'Testimonial',
      subTypes: []
    },
    {
      type: 'Advocacy',
      subTypes: [
        '',
        'Local',
        'State',
        'Federal'
      ]
    }
  ],
  initiativeTypes: [
    {text: '', value: null},
    {text: 'Health Equity', value: 'Health Equity'},
    {text: 'HR & Talent', value: 'HR & Talent'},
    {text: 'International Efforts', value: 'International Efforts'},
    {text: 'Medical Alley Starts', value: 'Medical Alley Starts'},
    {text: 'Supply Chain', value: 'Supply Chain'}
  ],
  activityBuilderMapping: [
    {
      text: '',
      value: null,
      definition: '',
      questionText: '',
      subTypes: []
    },
    {
      text: 'Content',
      value: 'Content',
      definition: '',
      questionText: 'What type of content is this?',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Webinar/In-Person Event',
          value: 'Webinar/In-Person',
          definition: ''
        },
        {
          text: 'Podcast',
          value: 'Podcast',
          definition: ''
        },
        {
          text: 'Written',
          value: 'Written',
          definition: ''
        },
        {
          text: 'Report',
          value: 'Report',
          definition: ''
        }
      ]
    },
    {
      text: 'Development',
      value: 'Development',
      questionText: 'What sort of development activity is this?',
      definition: '',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Prospecting',
          value: 'Prospecting',
          definition: ''
        },
        {
          text: 'Recruitment',
          value: 'Recruitment',
          definition: ''
        },
        {
          text: 'Result',
          value: 'Result',
          definition: ''
        },
        {
          text: 'Cost Savings Program',
          value: 'Cost Savings Program',
          definition: ''
        }
      ]
    },
    {
      text: 'Partnership',
      value: 'Partnership',
      questionText: 'What sort of partnership is this?',
      definition: '',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Prospecting',
          value: 'Prospecting',
          definition: ''
        },
        {
          text: 'Qualifying',
          value: 'Qualifying',
          definition: ''
        },
        {
          text: 'Sale',
          value: 'Sale',
          definition: ''
        },
        {
          text: 'Execution',
          value: 'Execution',
          definition: ''
        },
        {
          text: 'Completion',
          value: 'Completion',
          definition: ''
        },
        {
          text: 'Feedback',
          value: 'Feedback',
          definition: ''
        }
      ]
    },
    {
      text: 'Meeting',
      value: 'Meeting',
      questionText: 'What kind of meeting was this?',
      definition: 'The key here is selecting the right mode and observing any desired protocol for the type of meeting (e.g. how to refer to quarterly check-ins). Otherwise, a concise description is all that is required in the subject line (be sure to include a detailed note)! Other needed tagging, such as initiatives, happens via a separate tag.',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'In-Person',
          value: 'In-Person',
          definition: ''
        },
        {
          text: 'Virtual',
          value: 'Virtual',
          definition: ''
        },
        {
          text: 'Phone Call',
          value: 'Phone Call',
          definition: ''
        }
      ]
    },
    {
      text: 'Sponsorships',
      value: 'Sponsorships',
      questionText: 'What sort of sponsorship is this?',
      definition: '',
      subTypes: []
    },
    {
      text: 'Renewals',
      value: 'Renewals',
      questionText: 'What kind of renewal activity is this?',
      definition: 'Some of this documentation, especially the ‘drop notes’ will be recorded in multiple locations in the database. \n It is extremely important to include a detailed note to any entry in Renewals. For the ‘Survey’ summary notes are sufficient as the data will be recorded elsewhere, unless there are other notable items.',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Touchbase',
          value: 'Touchbase',
          definition: ''
        },
        {
          text: 'Invoiced',
          value: 'Invoiced',
          definition: ''
        },
        {
          text: 'Follow-up',
          value: 'Follow-up',
          definition: ''
        },
        {
          text: 'Survey',
          value: 'Survey',
          definition: ''
        },
        {
          text: 'Renewal Notes',
          value: 'Renewal Notes',
          definition: ''
        },
        {
          text: 'Drop Notes',
          value: 'Drop Notes',
          definition: ''
        }
      ]
    },
    {
      text: 'Referrals',
      value: 'Referrals',
      questionText: 'What kind of referral activity is this?',
      definition: '',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Direct',
          value: 'Direct',
          definition: ''
        },
        {
          text: 'Bulk',
          value: 'Bulk',
          definition: ''
        }
      ]
    },
    {
      text: 'Invitation',
      value: 'Invitation',
      questionText: '',
      definition: '',
      subTypes: []
    },
    {
      text: 'Testimonial',
      value: 'Testimonial',
      definition: 'What kind of testimonial is this?',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        }
      ]
    },
    {
      text: 'Advocacy',
      value: 'Advocacy',
      questionText: 'What type of advocacy activity is this?',
      definition: '',
      subTypes: [
        {
          text: '',
          value: null,
          definition: ''
        },
        {
          text: 'Local',
          value: 'Local',
          definition: ''
        },
        {
          text: 'State',
          value: 'State',
          definition: ''
        },
        {
          text: 'Federal',
          value: 'Federal',
          definition: ''
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/activities/ActivityConstants.js